import { legacyApiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BasePlainResource";
class BudgetResponsibleResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.email = "";
        this.firstName = "";
        this.lastName = "";
        this.phone = "";
        this.fullName = "";
    }
    pk() {
        return "GetBudgetResponsible";
    }
}
BudgetResponsibleResource.automaticValidation = "silent";
BudgetResponsibleResource.urlRoot = legacyApiResourceUrl("VulcanData/GetBudgetResponsible");
export { BudgetResponsibleResource };
//# sourceMappingURL=BudgetResponsibleResource.js.map